<router-outlet></router-outlet>
@if (saasSettingsService.appInitialized()) {
  <div class="disabled-overlay">
    <mat-spinner [diameter]="60" color="primary"></mat-spinner>
  </div>
}
